import {
  AnchorHTMLAttributes,
  FunctionComponent,
  PropsWithChildren,
} from "react";

type TProps = {
  className?: string;
  href: string;
  external?: boolean;
};

const Link: FunctionComponent<PropsWithChildren<TProps>> = (props) => {
  const externalProps: AnchorHTMLAttributes<HTMLAnchorElement> = {};

  if (props.external) {
    externalProps.target = "_blank";
    externalProps.rel = "noopener noreferrer";
  }

  return (
    <a href={props.href} className={props.className} {...externalProps}>
      {props.children}
    </a>
  );
};

export default Link;
